import { apiFetch } from "@/api/client";
import type { UserResponse } from "@/api/types";

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AcceptInvitePayload {
  token: string;
  password: string;
}

/** POST /api/auth/login — sets the httponly session cookie on success. */
export function login(payload: LoginPayload): Promise<UserResponse> {
  return apiFetch<UserResponse>("/api/auth/login", {
    method: "POST",
    body: payload,
  });
}

/** POST /api/auth/logout — 204 No Content, clears the cookie. */
export function logout(): Promise<void> {
  return apiFetch<void>("/api/auth/logout", { method: "POST" });
}

/** GET /api/auth/me — UI bootstrap; 401 means no session. */
export function getMe(): Promise<UserResponse> {
  return apiFetch<UserResponse>("/api/auth/me", { method: "GET" });
}

/** POST /api/auth/accept-invite — exchanges a token for a new user. */
export function acceptInvite(
  payload: AcceptInvitePayload,
): Promise<UserResponse> {
  return apiFetch<UserResponse>("/api/auth/accept-invite", {
    method: "POST",
    body: payload,
  });
}

export interface ResetPasswordPayload {
  token: string;
  password: string;
}

/**
 * Задать новый пароль по одноразовой ссылке от администратора.
 *
 * Возвращает 204 и намеренно не выдаёт сеанс: человек вводит новый пароль
 * на обычной странице входа и тем самым сразу проверяет, что запомнил
 * именно то, что задал.
 */
export function resetPassword(payload: ResetPasswordPayload): Promise<void> {
  return apiFetch<void>("/api/auth/reset-password", {
    method: "POST",
    body: payload,
  });
}
